import { createSlice } from '@reduxjs/toolkit';

import { ACTIONS } from '../../constants';
import { loadAttaches } from '../thunks/attaches.thunk';
import { IAttachesState } from './types';

const initialState: IAttachesState = {
  attachments: [],
  error: null,
  isLoading: false,
};

export const attachesSlice = createSlice({
  name: 'attaches',
  initialState,
  reducers: {
    attachesCloseError: (state) => {
      return {
        ...state,
        error: null,
      };
    },
    removeAttachment: (state, action) => {
      return {
        ...state,
        attachments: state.attachments.filter((i) => i.url !== action.payload),
        error: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAttaches.pending, (state) => {
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    });

    builder.addCase(loadAttaches.fulfilled, (state, action) => {
      return {
        attachments: [...state.attachments, ...action.payload],
        error: null,
        isLoading: false,
      };
    });

    builder.addCase(loadAttaches.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload as string,
        isLoading: false,
      };
    });

    builder.addCase(ACTIONS.SEND_MESSAGE, (state) => {
      return {
        ...state,
        attachments: [],
        error: null,
      };
    });
  },
});
